import { Component, OnInit } from "@angular/core";
import { AdobeLaunchService } from '../shared/services/adobe-launch.service';
@Component({
    selector: 'app-webinar-sign-up',
    templateUrl: './webinar-sign-up.component.html',
    styleUrls: ['./webinar-sign-up.component.scss']
})
export class WebinarSignUpComponent implements OnInit {
    sessions = [
        {
            program: 'MyCE Office Hours',
            date: new Date("2026-10-26T16:30:00-04:00"),
            link: "https://events.teams.microsoft.com/event/8397f09d-4a07-4485-97b2-a5db14203cc3@d3a74ac8-efe4-4fe8-b707-b1bf8c6a25bd?source=copyLinkLegacyShareLinkDialog"
        },
        {
            program: 'MyCI Office Hours',
            date: new Date("2026-10-29T18:00:00-04:00"),
            link: "https://events.teams.microsoft.com/event/bbecc33b-3535-4020-9339-e662347ac40d@d3a74ac8-efe4-4fe8-b707-b1bf8c6a25bd?source=copyLinkLegacyShareLinkDialog"
        },
        {
            program: 'MyCI Office Hours',
            date: new Date("2026-11-10T16:30:00-05:00"),
            link: "https://events.teams.microsoft.com/event/201782cf-846d-46b6-bc8a-a7bb2c06daf5@d3a74ac8-efe4-4fe8-b707-b1bf8c6a25bd?source=copyLinkLegacyShareLinkDialog"
        },
        {
            program: 'MyCE Office Hours',
            date: new Date("2026-11-12T18:00:00-05:00"),
            link: "https://events.teams.microsoft.com/event/8ccaebb2-6a67-4b61-bb26-58b19f4f4bb4@d3a74ac8-efe4-4fe8-b707-b1bf8c6a25bd?source=copyLinkLegacyShareLinkDialog"
        }
    ];
    filteredSessions: { program: string; date: Date; link: string }[] = [];

    constructor(
        private readonly adobeLaunchService: AdobeLaunchService
    ) {
    }

    ngOnInit(): void {
        this.adobeLaunchService.trackPageView({
            pageTitle:'Webinars'
        });

        // Keep a session visible until 1 hour after its start time
        const ONE_HOUR_MS = 60 * 60 * 1000;
        const now = new Date();
        this.filteredSessions = this.sessions.filter(session =>
            session.date.getTime() + ONE_HOUR_MS >= now.getTime()
        );
    }
}
